import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

class ThankYouPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      logo: props.location.state.logo
    };
  }

  componentDidMount() {
    const { history } = this.props;
    history.block(() => {
      alert(
        this.props.intl.formatMessage({
          id: 'redirect'
        })
      );
      return false;
    });

    window.addEventListener('popstate', () => {
      window.location.href = this.props.intl.formatMessage({
        id: 'redirect_to'
      });
    });
  }

  render() {
    const { logo } = this.state;
    return (
      <div>
        {logo && (
          <div>
            <h1 className="customer-renewal-view-logo">
              <img src={this.state.logo} alt="Logo" />
            </h1>
          </div>
        )}
        <div className="main-container">
          {this.props.intl.formatMessage({
            id: 'thank_you'
          })}
        </div>
      </div>
    );
  }
}

export default injectIntl(withRouter(ThankYouPage));
